import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {ProductPluReportModel} from "./product-plu-report.model";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";

@Component({
    selector: "wbo-product-plu-report-page",
    templateUrl: "./product-plu-report-page.component.html",
    providers: [provideReportModel(ProductPluReportModel)]
})
export class ProductPluReportPageComponent extends AbstractReportPage {
    constructor(public model: ProductPluReportModel) {
        super();
    }
}
